<template>
  <div>
    <div class="topBack">
      <i class="iconfont iconback" @click="onTopBack" />
    </div>
    <img src="/img/hbup.jpg" class="back">
    <div class="downRect">
      <img src="/img/hbdown.jpg" class="back">
      <div class="Body">
        <div class="title">活动规则</div>
        1.参与条件：潜水员<br>
        2.参与方式：1人参与，邀请2位潜水员即可成功组队<br>
        3.可以在展会现场获取或者选择邮寄<br>
        4.组队成功礼品：3人组队成功，每人获得<span style="font-weight: 700;">潜水员叮叮棒一根（价值58元）</span>；队伍不足3人，组队失败；队伍超过3人，第4人需另组队伍。<br>
        <div class="title">活动说明</div>
        1.每人仅限参与一次活动，每人仅限获得一根叮叮棒<br>
        2.组队发起人即是队长，不能弃队，只能找寻队员<br>
        3.礼品叮叮棒颜色随机，可以现场领取或选择邮寄<br>
        4.可以在展会现场获取或者选择邮寄<br>
        5.邮寄叮叮棒在成功组队后30天内发出<br>
        <div class="emptyRect" />
      </div>
    </div>
    <div class="downButton">
      <van-button type="info" square @click="onActivity" disabled >立刻参加[已结束]</van-button>
    </div>
  </div>
</template>
<script>
// import request from '@/utils/request'
import { getUrlKey } from '@/utils/base'
import { Button } from 'vant'
import Cookies from 'js-cookie'
export default {
  components: {
    [Button.name]: Button

  },
  data() {
    return {
    }
  },
  mounted() {
    console.log('进入')
    document.getElementsByTagName('body')[0].className = 'activeBacl'
  },
  destroyed: function() {
    console.log('离开')
    document.body.removeAttribute('class', 'activeBacl')
  },
  created() {
    var code = getUrlKey('c')
    if (code) {
      Cookies.set('activityCardKey_', code)
    }

    var url = getUrlKey('backurl')
    if (url !== null) {
      this.backurl = url
    }
  },
  methods: {
    onTopBack() {
      this.$router.replace('/home/index')
    },
    onActivity() {
      this.$router.replace('/activity/groupReg')
    }
  }
}
</script>
<style scoped>
.topBack{
   z-index: 100;
  position: absolute;
  left:1em;
  top: 1em;
  color: #fff;
}

.back{
  width: 100%;
  margin: 0;
  padding: 0;
  vertical-align:top;
}
.downRect{
  position: relative;
}
.Body{
  padding: 0 2em;
  margin-top: 1em;
  color: #fff;
  position: absolute;;
  left: 0;
  right: 0;
  top:0;
  line-height: 1.5em;
  font-size: 0.9em;
}
.title{
  font-size: 1.1em;
  font-weight: 700;
  margin: 2em 0 1em 0;
}
.emptyRect{
  height: 7em;
}
.downButton{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 62px;
}
.downButton button{
  background-color: #0092FA;
  border: #0092FA;
  width: 100%;
  height: 62px;
}
</style>
